import { authEntity } from "./entity";
import { IAuthData } from "@/api/auth/interface";
import { IAuthMethods } from './interface';
import router from "@/router";
import { profileEntity } from "@/models/modules/profile/entity";
import { IS_AUTH_KEY } from "@/models/modules/auth/storage";
import EventEmitter from "@/modules/Event/EventEmitter";
import { EventEmitterName } from "@/modules/Event/interface";
import { $logoutRequest } from "@/api/auth/auth";

export default <IAuthMethods> {

	signIn(v?: IAuthData): IAuthMethods {
		if (!v?.accessToken || !v?.refreshToken) {
			authEntity.authedState && this.signOut();

			return this;
		}

		authEntity.accessToken = v.accessToken;
		authEntity.refreshToken = v.refreshToken;
		authEntity.authedState = true;
		authEntity.customerSessionExpiredState = false;

		return this;
	},

	signOut(): IAuthMethods {
		authEntity.accessToken = authEntity.refreshToken = '';

		localStorage.removeItem('ulName');

		profileEntity.profileData = profileEntity.company = null;

		authEntity.authedState = false;

		if (this.isRouteLogin()) EventEmitter.emit(EventEmitterName.LOGOUT);

		return this;
	},

	signOutAndRedirectToAuth() {
		this.signOut();

		if (this.isRouteLogin()) router.push({ name: "Login" }).catch(() => {});
	},

	saveAuthToSession(): IAuthMethods {
		authEntity.accessTokenInSession = authEntity.accessToken;
		authEntity.refreshTokenInSession = authEntity.refreshToken;

		return this;
	},

	clearAuthFromMainStorage(): IAuthMethods {
		authEntity.accessToken = authEntity.refreshToken = '';

		return this;
	},

	clearAuthFromSession(): IAuthMethods {
		authEntity.accessTokenInSession = authEntity.refreshTokenInSession = '';

		return this;
	},

	authFromSession(): IAuthMethods {
		if (authEntity.accessToken && authEntity.refreshToken) return this;

		return this.signIn({
			accessToken: authEntity.accessTokenInSession,
			refreshToken: authEntity.refreshTokenInSession
		});
	},

	init() {
		this.authFromSession().clearAuthFromSession().initStorageEvent().initBeforeUnloadEvent();
	},

	initBeforeUnloadEvent(): IAuthMethods {
		window.addEventListener('beforeunload', () =>
			this.saveAuthToSession().clearAuthFromMainStorage());

		return this;
	},

	initStorageEvent(): IAuthMethods {
		window.addEventListener('storage', (e) => {
			if (e.key !== IS_AUTH_KEY) return;

			if (!e.newValue || e.newValue === '0') {

				this.signOut();

				router.push({ name: 'Login' }).catch(() => {});

			} else {

				this.signIn({
					refreshToken: authEntity.refreshToken,
					accessToken: authEntity.accessToken
				});

				router.push({ name: 'Home' }).catch(() => {});

			}
		});

		return this;
	},

	isRouteLogin(): boolean {
		return router.currentRoute.name !== "Login"
	},

	async signOutLocal() {
		await $logoutRequest();
		this.clearAuthFromMainStorage().clearAuthFromSession();
	}

}